import "@draft-js-plugins/linkify/lib/plugin.css";
import "@draft-js-plugins/mention/lib/plugin.css";
import "draft-js/dist/Draft.css";
import "react-toastify/dist/ReactToastify.css";
import "swiper/css";

import * as Sentry from "@sentry/browser";
import React from "react";
import { createRoot } from "react-dom/client";
import { configureI18n, getLocale } from "@assets/strings";
import { Environment } from "@core/config/environment";
import { sentryDataCollection } from "@core/config/sentry";
import { AppInitialStateDto, appInitialStateFromDto } from "@domain/initialState/appInitialState";
import { App } from "./app";
import { initializeBrowserServices } from "./initializeBrowserServices";

interface Window {
	__INITIAL_STATE?: AppInitialStateDto;
}

Sentry.init({
	dsn: Environment.SENTRY_DSN,
	integrations: [Sentry.browserApiErrorsIntegration()],
	dataCollection: sentryDataCollection,
	environment: window.location.host,
	release: Environment.LABEL_VERSION,
	// Set tracesSampleRate to 1.0 to capture 100%
	// of transactions for performance monitoring.
	// We recommend adjusting this value in production
	tracesSampleRate: parseFloat(Environment.SENTRY_TRACES_SAMPLE_RATE || "1"),
});

console.log(`TooShare version - ${Environment.LABEL_VERSION}`);

configureI18n(getLocale(navigator.languages));

if ("serviceWorker" in navigator) {
	navigator.serviceWorker.register(new URL("../sw.ts", import.meta.url)).catch(function (error) {
		console.log("Service worker registration failed, error:", error);
	});
}

const root = document.getElementById("main");
if (!root) throw new Error("React root not found");

const initialState = (window as Window).__INITIAL_STATE;
delete (window as Window).__INITIAL_STATE;

const services = initializeBrowserServices(initialState && appInitialStateFromDto(initialState));

// Use hydrateRoot to hydrate the existing server-rendered content
//hydrateRoot(root, <App services={services} />);
createRoot(root).render(<App services={services} />);
